import React, { useState, useEffect } from 'react';
import {
    Grid,
    TextField,
    Typography,
    Card,
    Link,
} from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import SimpleFooter from "examples/Footers/SimpleFooter";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import routes from "routes";
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import Container from "@mui/material/Container";
import MKTypography from "components/MKTypography";
import Autocomplete from '@mui/material/Autocomplete';
import SearchIcon from "@mui/icons-material/Search";
import 'react-datepicker/dist/react-datepicker.css';
import { useNavigate } from 'react-router-dom';
import Advertisement from '../Advertisement/Advertisement';

const Page = () => {
    const [search, setSearch] = useState("");
    const [location, setLocation] = useState("");
    const [budget, setBudget] = useState("");
    const [budgetRangeFrom, setBudgetRangeFrom] = useState("");
    const [budgetRangeTo, setBudgetRangeTo] = useState("");
    const [skillsName, setSkillsName] = useState([]);
    const [trainerList, setTrainerList] = useState([]);
    const [bbdata, setbbData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [errorMessage, setErrorMessage] = useState("");

    const displayAdvertisement = process.env.REACT_APP_ADVERTISEMENT === 'yes';

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/api/skill-details/`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + localStorage.getItem("token"),
            },
        })
            .then((resp) => resp.json())
            .then((data) => {
                if (data.detail) {
                } else {
                    setSkillsName(data);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }, []);
    console.log("skillsName", skillsName);

    const navigate = useNavigate();

    const onSubmitClick = async () => {
        if (!search && !location && !budgetRangeFrom && !budgetRangeTo) {
            setErrorMessage("Please apply filters to search Trainer");
        } else {
            const queryString = `?search=${search}&location=${location}&budgetRangeFrom=${budgetRangeFrom}&budgetRangeTo=${budgetRangeTo}`;
            navigate(`/app/navtrainerlist${queryString}`);
        }
    };

    const handleSearchChange = (event, value) => {
        setSearch(value);
    };
    console.log("search", search);


    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/api/trainer-page-less/?avgCommercialFor8hrs__gte=${budgetRangeFrom}&avgCommercialFor8hrs__lte=${budgetRangeTo}&skills__icontains=${search}&location__icontains=${location}&page=${currentPage}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token'),
            },
        })
            .then((resp) => resp.json())
            .then((data) => {
                if (!data.detail) {
                    setbbData(data);
                    setTrainerList(data.results);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }, [budgetRangeFrom, budgetRangeTo, search, location, currentPage]);

    console.log("trainerList", trainerList);
    console.log("data", bbdata);

    const onClearFilterClick = () => {
        setSearch("");
        setBudget("");
        setBudgetRangeFrom("");
        setBudgetRangeTo("");
        setLocation("");
        setErrorMessage("");
    };

    return (
        <>
            <DefaultNavbar
                routes={routes}
                sticky
            />
            <Card
                sx={{
                    height: '790px',
                    p: 2,
                    mx: { xs: 2, lg: 3 },
                    mt: -8,
                    mb: 4,
                    // backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
                    backdropFilter: "saturate(200%) blur(30px)",
                    boxShadow: ({ boxShadows: { xxl } }) => xxl,
                }}
            >
                <Container maxWidth="sm">
                    <form>
                        <Grid container style={{ marginTop: "130px" }} spacing={2}>
                            <Grid item xs={12} sm={3}>
                                <MKTypography style={{ whiteSpace: 'nowrap' }} variant="h2" color="text">
                                    <span style={{ color: 'black' }}>Search</span>{' '}
                                    <span style={{ color: 'rgb(60, 150, 190)' }}>Trainer</span>
                                </MKTypography>
                            </Grid>
                        </Grid>
                        <Grid container style={{ marginTop: '20px', marginLeft: '0px' }} spacing={2}>
                            {/* <Grid item xs={12} sm={3}> */}
                            <div>
                                <Typography variant="h5" style={{ color: 'black' }}>Search by Skills</Typography>
                                <Autocomplete
                                    id="skills"
                                    options={skillsName}
                                    freeSolo
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Skill"
                                            variant="standard"
                                            style={{ marginTop: '10px', width: '700px' }}
                                            fullWidth
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <SearchIcon fontSize="medium" />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    )}
                                    onChange={(event, value) => handleSearchChange(event, value)}
                                />
                            </div>
                            {/* </Grid> */}
                            <Grid item xs={12} md={8}>
                                <Grid item xs={12} md={10}>
                                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px', marginLeft: '-20px' }}>
                                        {/* <Link href="#" onClick={onClearFilterClick} style={{ marginTop: '-15px', textDecoration: 'underline', color: 'blue', cursor: 'pointer', fontSize: 'small' }}>
                                            Clear Filters
                                        </Link> */}
                                        <MKButton variant="gradient" color="info" size="small" style={{ marginTop: '-15px', whiteSpace: 'nowrap' }} onClick={onClearFilterClick} >Clear Filters</MKButton>
                                        <MKButton variant="gradient" color="info" size="small" style={{ marginTop: '-15px', marginLeft: '10px' }} onClick={onSubmitClick} >Submit</MKButton>
                                    </div>
                                </Grid>
                                <div>
                                    {errorMessage && <Typography color="error" style={{ marginLeft: "-15px", marginTop: "10px", fontSize: "13px", lineHeight: "1.2" }}>{errorMessage}</Typography>}
                                </div>
                            </Grid>
                        </Grid>
                        {displayAdvertisement && <Advertisement />}
                    </form>
                </Container>
            </Card>
            <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <MKBox position="center" zIndex={2} style={{ bottom: 0 }}>
                    <SimpleFooter />
                </MKBox>
            </div>
        </>
    );
}

export default Page;

